'use client'

import React, {useState, useRef, useEffect} from 'react'
import StayContext from './StayContext'

export default function ({children, value}) {
	const focusGuest = useRef(false)
	const [roomPackage, setRoomPackage] = useState('')
	const [room, setRoom] = useState('')
	const [date, setDate] = useState(null)
	const [guests, setGuests] = useState('')
	const [packageNightCount, setPackageNightCount] = useState(null)
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

	useEffect(() => {
		if (focusGuest.current) {
			setTimeout(() => {
				focusGuest.current = false
			}, 1000)
		}
	}, [focusGuest.current])

	return (
		<StayContext.Provider value={{...value, roomPackage, setRoomPackage, room, setRoom, date, setDate, guests, setGuests, focusGuest, packageNightCount, setPackageNightCount, mobileMenuOpen, setMobileMenuOpen}}>
			{children}
		</StayContext.Provider>
	)
}
